import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Map, TileLayer } from 'react-leaflet'

import CharacterDropIn from '../components/CharacterDropIn'
import SwappableDiv from '../components/SwappableDiv'

import { swapDiv } from '../actions/actions'

class GraphistryWLAN extends Component {
    constructor(props) {
        super(props)
        this.DEFAULT_VIEWPORT = {
            center: [38.303065, -77.458153],
            zoom: 15,
        }
        this.state = {
            viewport: this.DEFAULT_VIEWPORT,
            showDiv: false,
        }
    }

    swapdiv = () => {
        this.props.dispatch( swapDiv() )
    }

    render() {
        return(
            <div>
                <nav className="pt-navbar">
                    <div className="pt-navbar-group pt-align-left">
                        <div className="pt-navbar-heading">
                            <b><CharacterDropIn value={'Jamal Mahboob: GraphistryWLAN Test'} /></b>
                        </div>
                    </div>
                    {/*<div className="pt-navbar-group pt-align-right">
                        <div className="pt-navbar-heading pt-button-group">
                            <button className="pt-button" onClick={() => this.setState({ showDiv: !this.state.showDiv })}>
                                {this.state.showDiv ? "Hide Text" : "Show Text"}
                            </button>
                            <button className="pt-button" onClick={this.swapdiv}>
                                Swap Div
                            </button>
                        </div>
                    </div>*/}
                </nav>

                { this.state.showDiv && <SwappableDiv /> }

                <div className="graphistry_left">
                    <iframe frameBorder={0} style={{width: '100%', height: '100%'}}
                        src="https://static.jamalmahboob.com/Graphistry_80211.html"
                    />
                </div>
                <div className="graphistry_right">
                    <iframe frameBorder={0} style={{width: '100%', height: '100%'}} 
                        src="https://labs.graphistry.com/graph/graph.html?dataset=PyGraphistry%2F7HXRKQYZNH&type=vgraph&viztoken=ab4a56641fe26050973323df53455398d1d33b80&usertag=6325d710-pygraphistry-0.9.51&info=true&workbook=4231660f54ce6929"
                    />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {}
}

export default connect(mapStateToProps)(GraphistryWLAN)



// WEBPACK FOOTER //
// ./src/containers/GraphistryWLAN.js